import React, { useState, useEffect } from 'react';
import { FaStar, FaLinkedinIn, FaBriefcase, FaBuilding, FaAward, FaGlobe } from 'react-icons/fa';
import axios from "axios";
import { useParams } from "react-router-dom/cjs/react-router-dom";
import '../../assets/css/mentor.css'; // Ensure this file contains Code 2's CSS
import SecurityHeaders from "../../data/SecurityHeaders";
import ENDPOINT from "../../context/ENDPOINT";

const SingleMentor = () => {
  const [mentor, setMentor] = useState(null);
  const [isAnimated, setIsAnimated] = useState(false);
  const params = useParams();

  const fetchMentors = async () => {
    try {
      const formData = new FormData();
      formData.append("mentor_id", params.id);

      const res = await axios.post(ENDPOINT + "get-mentor.php", formData, SecurityHeaders);

      if (res) {
        console.log(res.data);
        setMentor(res.data.mentor);
      }
    } catch (error) {
      console.error("Error fetching mentors:", error);
    }
  };

  useEffect(() => {
    fetchMentors();
  }, [params.id]);

  useEffect(() => {
    const timer = setTimeout(() => setIsAnimated(true), 100);
    return () => clearTimeout(timer);
  }, []);

  if (!mentor) {
    return <p className="text-center py-5">Loading mentor...</p>;
  }

  const renderStars = (ratingValue) => {
    const stars = [];
    const fullStars = Math.floor(ratingValue);
    const hasHalf = ratingValue % 1 >= 0.5;

    for (let i = 1; i <= 5; i++) {
      if (i <= fullStars) {
        stars.push(<FaStar key={i} className="star-filled" />);
      } else if (i === fullStars + 1 && hasHalf) {
        stars.push(<FaStar key={i} className="star-half" />);
      } else {
        stars.push(<FaStar key={i} className="star-empty" />);
      }
    }
    return stars;
  };

  const wrapperClasses = `mentor-profile-wrapper ${isAnimated ? 'is-animated' : ''}`;

  return (
    <div id="hacking-mentor-profile" className={wrapperClasses}>
      <div className="mentor-card-new row no-gutters">

        {/* Left: Profile Image + Social */}
        <div className="col-12 col-lg-4 mentor-image-section">
          {/* <img
            src={mentor.cover_img || mentor.profile_pic}
            alt="Cover"
            className="mentor-cover-bg"
            style={{ width: '100%', height: '100%', objectFit: 'cover', position: 'absolute', top: 0, left: 0, zIndex: 0 }}
          /> */}
          <div style={{ position: 'relative', zIndex: 1, padding: '20px' }}>
            <img
              src={mentor.profile_pic}
              alt={`${mentor.first_name} ${mentor.last_name}`}
              className="mentor-profile-pic"
            />
            {/* <div className="mentor-social-links">
              {mentor.linkedin && (
                <a href={mentor.linkedin} target="_blank" rel="noopener noreferrer" className="mentor-social-link">
                  <FaLinkedinIn />
                </a>
              )}
            </div> */}
          </div>
        </div>

        {/* Right: Info Section */}
        <div className="col-12 col-lg-8 mentor-info-section">

          {/* Name & Tagline */}
          <div className="mentor-name-tagline-wrapper">
            <h2 className="mentor-name">{mentor.first_name} {mentor.last_name}</h2>
            <p className="mentor-tagline">{mentor.skill_title || "Expert Mentor"}</p>
          </div>

          {/* Roles */}
          <div className="mentor-roles">
            <span>{mentor.trains_at || "Online & In-Person"}</span>
          </div>

          {/* Bio */}
          <p className="mentor-bio">{mentor.bio || "No information available."}</p>

          {/* Achievements Grid */}
          <div className="mentor-achievements-grid mt-3">
            <div className="mentor-achievement-item">
              <FaBriefcase /> {mentor.experience} Years Experience
            </div>
            <div className="mentor-achievement-item">
              <FaBuilding /> {mentor.company_name || "Top MNC"}
            </div>
            <div className="mentor-achievement-item">
              <FaAward /> Expert in {mentor.skill_title}
            </div>
            <div className="mentor-achievement-item">
              <FaGlobe /> Proficient in {mentor.skills || "Multiple Technologies"} Technologies
            </div>
          </div>

          {/* Rating */}
          <div className="mentor-rating-section">
            {mentor.ratings}/5
            <div className="mentor-rating-stars">
              {renderStars(mentor.ratings)}
            </div>
            <span className="mentor-review-count">(Based on performance)</span>
          </div>

          {/* Action Buttons */}
          <div className="mentor-action-buttons">
            <a href="#" className="btn-action-primary">
              Book a Session
            </a>
            <a href={mentor.linkedin || "#"} className="btn-action-secondary">
              View LinkedIn
            </a>
          </div>

          {/* Experience Section */}
          {mentor.job_title && (
            <div className="mt-4 p-3 border rounded mentor-experience-box">
              <h5 className="mb-2">
                <FaBriefcase className="me-2" />
                Current Role
              </h5>
              <p className="mb-1"><strong>{mentor.job_title}</strong></p>
              <p className="text-muted small">
                {mentor.company_name} · {mentor.employment_type}
              </p>
            </div>
          )}

          {/* Skills Section */}
          {/* {mentor.skills && (
            <div className="mt-3 p-3 border rounded mentor-skills-box">
              <h5 className="mb-2">
                <FaStar className="me-2" />
                Key Skills
              </h5>
              <p className="mb-0">{mentor.skills}</p>
            </div>
          )} */}

        </div>
      </div>
    </div>
  );
};

export default SingleMentor;